import { parsePhoneNumber } from 'libphonenumber-js';
import * as React from 'react';

export const getPhoneNumber = (number: string) => {
  if (number.length > 10 && number.indexOf('+') === -1) {
    number = '+' + number;
  }

  const phoneNumber = parsePhoneNumber(number, 'US');

  // Even if the number is "invalid", assume US was the intended country
  phoneNumber.country = phoneNumber.country || 'US';

  return phoneNumber;
}

export const formatPhoneNumber = (number: string) => {
  number = (number ?? '').trim();
  if (number == '') {
    return number;
  }

  try {
    const phoneNumber = getPhoneNumber(number);
    return phoneNumber.country == 'US' ? phoneNumber.formatNational() : phoneNumber.formatInternational();
  } catch (e) {
    return number
  }
}

export const toE164 = (number: string) => {
  number = (number ?? '').trim();
  if (number == '') {
    return number;
  }

  try {
    const phoneNumber = getPhoneNumber(number);
    return phoneNumber.format('E.164');
  } catch (e) {
    return "Invalid Phone Number"
  }
}

export interface IPhoneNumberProps {
  value: string
}

export const PhoneNumber = (props:IPhoneNumberProps) =>
  <span>{formatPhoneNumber(props.value)}</span>
